// extracted by mini-css-extract-plugin
module.exports = {"modal":"KaT2fOfa","sendEmail":"yWa16Pqd","getKey":"w7CbRexr","step":"Z0fKqSan","desc":"qD_t03Oz","emphasize":"fDCAaWBp"};